// الإعدادات — تُفتح مرة واحدة عند الإعداد، ونادراً بعدها.
// هنا يُسأل المستخدم الأسئلة التي وفّرناها عليه في كل حركة: نوع البند، وهل هو ثابت.

import { fmt, esc } from '../util.js';
import {
  state, CURRENCIES, usageCount, liveEntries, pendingCount, stats,
  addDest, addType, renameDest, renameType, removeDest, removeType,
  restoreDest, restoreType, toggleFixed, setTheme, clearLocal
} from '../store.js';
import { api, ApiError } from '../api.js';
import { sync, syncStatus } from '../sync.js';
import { topBar, askName, icon } from '../ui.js';

export function render(app){
  const pending = pendingCount();
  const status = syncStatus();
  const statusText = {
    idle: 'كل شيء مزامَن', syncing: 'جارٍ المزامنة…',
    offline: 'بلا اتصال — سيُزامَن تلقائياً', error: 'تعذّرت المزامنة — سنعيد المحاولة',
    auth: 'انتهت الجلسة — سجّل دخولاً'
  }[status] || '';

  const destRows = state.dests.map(d => {
    const off = d.archived || d.deleted;
    return `<div class="switchrow">
      <span class="nm">${esc(d.name)}${off ? ' <small style="color:var(--up)">مؤرشفة</small>' : ''}
        <small>${usageCount('dest', d.id)} حركة</small></span>
      ${off
        ? `<button type="button" class="btn sm" data-restore-dest="${d.id}">إرجاع</button>`
        : `<button type="button" class="btn sm" data-rename-dest="${d.id}">${icon('i-pen', 14)}</button>
           <button type="button" class="btn sm danger" data-del-dest="${d.id}">${icon('i-trash', 14)}</button>`}
    </div>`;
  }).join('');

  const typeRows = state.types.map(t => {
    const off = t.archived || t.deleted;
    return `<div class="switchrow">
      <span class="nm">${esc(t.name)}${off ? ' <small style="color:var(--up)">مؤرشف</small>' : ''}
        <small>${usageCount('type', t.id)} حركة${t.isFixed ? ' · ثابت' : ''}</small></span>
      ${off
        ? `<button type="button" class="btn sm" data-restore-type="${t.id}">إرجاع</button>`
        : `<button type="button" class="tog" data-fixed="${t.id}" aria-pressed="${!!t.isFixed}"
             aria-label="مصروف ثابت"></button>
           <button type="button" class="btn sm" data-rename-type="${t.id}">${icon('i-pen', 14)}</button>
           <button type="button" class="btn sm danger" data-del-type="${t.id}">${icon('i-trash', 14)}</button>`}
    </div>`;
  }).join('');

  const h = state.household || {};
  const rates = h.rates || {};
  const curRows = Object.keys(CURRENCIES).slice(0, 3).map(c => `
    <div class="switchrow">
      <span class="nm">${CURRENCIES[c].name} ${CURRENCIES[c].sym}
        <small>${c === h.baseCurrency ? 'العملة الأساسية'
                : `1 ${CURRENCIES[c].sym} = ${rates[c] || '—'} ${(CURRENCIES[h.baseCurrency] || {}).sym || ''}`}</small></span>
      ${c === h.baseCurrency
        ? '<span class="tag d">أساسية</span>'
        : `<button type="button" class="btn sm" data-rate="${c}">تعديل السعر</button>`}
    </div>`).join('');

  const members = (state.members || []).map(m => `
    <div class="switchrow">
      <span class="nm">${esc(m.displayName || m.username)}
        <small>${m.role === 'owner' ? 'مالك المحفظة' : 'عضو'}${m.id === state.user.id ? ' · أنت' : ''}</small></span>
    </div>`).join('');

  const themes = [['system', 'حسب النظام'], ['light', 'فاتح'], ['dark', 'داكن']];

  return topBar('الإعدادات',
      `${esc(state.user.username)} · ${stats().totalEntries || 0} حركة`)
    + `<div class="scroll">

      <div class="card">
        <h3>المزامنة</h3>
        <p class="desc">${esc(statusText)}${pending ? ` · <b>${pending}</b> عملية في الطابور` : ''}</p>
        <div class="btnrow">
          <button type="button" class="btn primary" data-act="sync">مزامنة الآن</button>
          <button type="button" class="btn" data-act="logout">تسجيل الخروج</button>
        </div>
      </div>

      <div class="card">
        <h3>المحفظة المشتركة</h3>
        <p class="desc">شارك رمز الدعوة مع زوجتك أو أبنائك الكبار ليسجّلوا في نفس المحفظة.
        الحركات تظهر عند الجميع فوراً.</p>
        ${members}
        ${h.inviteCode ? `
          <div class="reccode small" style="margin:10px 0">${esc(h.inviteCode)}</div>
          <div class="btnrow">
            <button type="button" class="btn" data-act="copy-invite">نسخ رمز الدعوة</button>
            ${state.user.role === 'owner'
              ? '<button type="button" class="btn" data-act="rotate-invite">تجديد الرمز</button>' : ''}
          </div>` : ''}
        <div class="btnrow" style="margin-top:9px">
          <button type="button" class="btn" data-act="join">الانضمام لمحفظة أخرى</button>
        </div>
      </div>

      <div class="card">
        <h3>الوجهات</h3>
        <p class="desc">لمن أو لأين ذهب المال. أبقِها قصيرة —
        فوق العشرين تصبح شاشة الاختيار أبطأ من الكتابة اليدوية.</p>
        ${destRows}
        <div class="btnrow" style="margin-top:11px">
          <button type="button" class="btn primary" data-act="adddest">＋ وجهة جديدة</button>
        </div>
      </div>

      <div class="card">
        <h3>الأنواع</h3>
        <p class="desc">على ماذا صُرف المال. المفتاح يعني <b>مصروف ثابت</b> —
        إيجار وفواتير وأقساط ومدرسة. هذا ما يفصل المتغيّر الذي تستطيع التحكم به.</p>
        ${typeRows}
        <div class="btnrow" style="margin-top:11px">
          <button type="button" class="btn primary" data-act="addtype">＋ نوع جديد</button>
        </div>
      </div>

      <div class="card">
        <h3>العملات</h3>
        <p class="desc">تُسجَّل كل حركة بعملتها الحقيقية، وتُحوَّل في التقارير فقط.</p>
        ${curRows}
      </div>

      <div class="card">
        <h3>المظهر</h3>
        <div class="btnrow">
          ${themes.map(([id, label]) =>
            `<button type="button" class="btn${state.theme === id ? ' primary' : ''}" data-theme="${id}">${label}</button>`
          ).join('')}
        </div>
      </div>

      <div class="card">
        <h3>البيانات</h3>
        <p class="desc">بياناتك على خادمك أنت. صدّر نسخة احتياطية بين حين وآخر.</p>
        <div class="btnrow">
          <button type="button" class="btn" data-act="export">تصدير نسخة</button>
          <button type="button" class="btn" data-act="import">استيراد نسخة</button>
          <button type="button" class="btn" data-act="demo">بيانات تجريبية</button>
          ${state.user.role === 'owner'
            ? `<button type="button" class="btn danger" data-act="purge">حذف بيانات فترة</button>
               <button type="button" class="btn danger" data-act="reset">مسح كل الحركات</button>` : ''}
        </div>
        <input type="file" id="importFile" accept="application/json,.json" hidden>
      </div>

      <div class="card">
        <h3>الحساب</h3>
        <p class="desc">أجهزتك الداخلة بحسابك، وحذف الحساب نهائياً.</p>
        <div class="btnrow">
          <button type="button" class="btn" data-act="devices">أجهزتي</button>
          <button type="button" class="btn danger" data-act="account">حذف الحساب</button>
        </div>
      </div>

      <p class="note-sm" style="text-align:center;padding:6px 0 10px">
        محفظة العائلة · نسخة ١٫٠<br>
        <span style="opacity:.7;direction:ltr;display:inline-block">${esc(api.baseUrl())}</span>
      </p>
    </div>`;
}

export function mount(app, root){
  const file = root.querySelector('#importFile');
  if (!file) return;
  file.addEventListener('change', async () => {
    const f = file.files && file.files[0];
    if (!f) return;
    try {
      const dump = JSON.parse(await f.text());
      const res = await api.importData(dump);
      await app.refresh();
      app.toast(`استُوردت ${res.entriesInserted} حركة`);
    } catch (err){
      app.toast(err instanceof ApiError ? err.message : 'ملف غير صالح');
    }
    file.value = '';
  });
}

/**
 * تنزيل نسخة احتياطية — مشتركة مع شاشة حذف الحساب.
 * من قرّر الحذف يحتاج التصدير في طريقه لا في شاشة أخرى.
 */
export async function exportBackup(app){
  try {
    const dump = await api.exportData();
    const blob = new Blob([JSON.stringify(dump, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `family-wallet-${new Date().toISOString().slice(0, 10)}.json`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    app.toast('تم تصدير نسخة احتياطية');
  } catch (err){ app.toast(err.message); }
  return true;
}

export async function onClick(app, btn){
  const d = btn.dataset;

  if (d.renameDest){ const v = askName('الاسم الجديد:'); if (v) renameDest(d.renameDest, v); app.queueSync(); return app.render(); }
  if (d.renameType){ const v = askName('الاسم الجديد:'); if (v) renameType(d.renameType, v); app.queueSync(); return app.render(); }
  if (d.delDest){
    const used = removeDest(d.delDest);
    app.toast(used ? 'أُرشفت — حركاتها القديمة سليمة' : 'حُذفت الوجهة');
    app.queueSync(); return app.render();
  }
  if (d.delType){
    const used = removeType(d.delType);
    app.toast(used ? 'أُرشف — حركاته القديمة سليمة' : 'حُذف النوع');
    app.queueSync(); return app.render();
  }
  if (d.restoreDest){ restoreDest(d.restoreDest); app.queueSync(); return app.render(); }
  if (d.restoreType){ restoreType(d.restoreType); app.queueSync(); return app.render(); }
  if (d.fixed){ toggleFixed(d.fixed); app.queueSync(); return app.render(); }
  if (d.theme){ setTheme(d.theme); return app.render(); }

  if (d.rate){
    const cur = d.rate;
    const h = state.household || {};
    const baseSymbol = (CURRENCIES[h.baseCurrency] || {}).sym || '';
    const v = askName(`كم ${baseSymbol} يساوي 1 ${CURRENCIES[cur].sym}؟`, String((h.rates || {})[cur] || ''));
    if (v && Number(v) > 0){
      try {
        const res = await api.updateHousehold({ rates: { ...h.rates, [cur]: Number(v) } });
        state.household = res.household;
        app.toast('حُدّث سعر الصرف');
      } catch (err){ app.toast(err.message); }
    }
    return app.render();
  }

  const act = d.act;

  if (act === 'adddest'){ const v = askName('اسم الوجهة (لمن أو لأين):'); if (v) addDest(v); app.queueSync(); return app.render(); }
  if (act === 'addtype'){ const v = askName('اسم النوع (على ماذا):'); if (v) addType(v); app.queueSync(); return app.render(); }

  if (act === 'sync'){
    app.toast('جارٍ المزامنة…');
    try { await sync({ force: true }); await app.refresh(); app.toast('تمّت المزامنة'); }
    catch (err){ app.toast(err.message || 'تعذّرت المزامنة'); }
    return;
  }

  if (act === 'logout'){
    if (pendingCount() && !confirm(
      `لديك ${pendingCount()} عملية لم تُرسَل بعد. الخروج الآن قد يفقدها. متابعة؟`)) return;
    return app.logout();
  }

  if (act === 'copy-invite'){
    const code = (state.household || {}).inviteCode || '';
    navigator.clipboard?.writeText(code)
      .then(() => app.toast('نُسخ رمز الدعوة'))
      .catch(() => app.toast('انسخه يدوياً: ' + code));
    return;
  }

  if (act === 'rotate-invite'){
    if (!confirm('سيتوقّف الرمز القديم عن العمل. متابعة؟')) return;
    try {
      const res = await api.rotateInvite();
      state.household.inviteCode = res.inviteCode;
      app.toast('جُدّد رمز الدعوة');
    } catch (err){ app.toast(err.message); }
    return app.render();
  }

  if (act === 'join'){
    const code = askName('أدخل رمز الدعوة الذي وصلك:');
    if (!code) return;
    try {
      await api.joinHousehold(code);
      await app.hardRefresh();
      app.toast('انضممت إلى المحفظة');
    } catch (err){ app.toast(err.message); }
    return;
  }

  if (act === 'export') return exportBackup(app);

  if (act === 'import'){ document.querySelector('#importFile')?.click(); return; }

  if (act === 'demo'){
    if (!confirm('سيضيف ٦٠ يوماً من حركات تجريبية إلى محفظتك. متابعة؟')) return;
    app.toast('جارٍ التوليد…');
    try {
      const res = await api.demoData(60);
      await app.hardRefresh();
      app.toast(`أُضيفت ${res.created} حركة تجريبية`);
    } catch (err){ app.toast(err.message); }
    return;
  }

  if (act === 'purge'){
    app.openSub('purge');
    return true;
  }

  if (act === 'account'){
    app.openSub('account');
    return true;
  }

  if (act === 'devices'){
    app.openSub('devices');
    return true;
  }

  if (act === 'reset'){
    if (!confirm('سيُمسح كل حركات المحفظة نهائياً. هل أنت متأكد؟')) return;
    if (!confirm('تأكيد أخير — لا يمكن التراجع. امسح كل الحركات؟')) return;
    try {
      const res = await api.resetData();
      await app.hardRefresh();
      app.toast(`مُسحت ${res.deleted} حركة`);
    } catch (err){ app.toast(err.message); }
    return;
  }
  return false;
}
